// This file is AUTOGENERATED, do not edit it manually!!!

import { users as usersde } from './usersResx.de';
import { users as usersen } from './usersResx.en';
import { users as usersen_risk } from './usersResx.en_risk';
import { users as userses } from './usersResx.es';
import { users as usersfr } from './usersResx.fr';
import { users as usersit } from './usersResx.it';
import { users as usersnl } from './usersResx.nl';
import { users as userspl } from './usersResx.pl';
import { users as userspt } from './usersResx.pt';
import { users as usersru } from './usersResx.ru';
import { users as userssk } from './usersResx.sk';
import { users as userssv } from './usersResx.sv';
import { users as userstr } from './usersResx.tr';

const langMap: { [k: string]: Partial<typeof usersen> } = {
    de: usersde,
    en: usersen,
    en_risk: usersen_risk,
    es: userses,
    fr: usersfr,
    it: usersit,
    nl: usersnl,
    pl: userspl,
    pt: userspt,
    ru: usersru,
    sk: userssk,
    sv: userssv,
    tr: userstr,
};

/* tslint:disable: max-line-length */
export const usersResx = {
    /**
    * en: Active
    */
    get active() {
        return langMap[ep.resxCulture].active || langMap.en.active;
    },
    /**
    * en: By setting the user's Active property to off, you do two things: free up a license for some other user and make the inactive user invisible everywhere in the system except the Users page.
    */
    get active_switch_description() {
        return langMap[ep.resxCulture].active_switch_description || langMap.en.active_switch_description;
    },
    /**
    * en: Add user
    */
    get add_user() {
        return langMap[ep.resxCulture].add_user || langMap.en.add_user;
    },
    /**
    * en: Apply
    */
    get apply() {
        return langMap[ep.resxCulture].apply || langMap.en.apply;
    },
    /**
    * en: Add
    */
    get assign() {
        return langMap[ep.resxCulture].assign || langMap.en.assign;
    },
    /**
    * en: Assigned activities
    */
    get assigned_activities_menu_title() {
        return langMap[ep.resxCulture].assigned_activities_menu_title || langMap.en.assigned_activities_menu_title;
    },
    /**
    * en: Can login
    */
    get can_login() {
        return langMap[ep.resxCulture].can_login || langMap.en.can_login;
    },
    /**
    * en: By turning off Can login, you only deny the user access to the system. The user can still be a project member or assignee. This action will also free up a license if you need one.
    */
    get can_login_switch_description() {
        return langMap[ep.resxCulture].can_login_switch_description || langMap.en.can_login_switch_description;
    },
    /**
    * en: Cancel
    */
    get cancel() {
        return langMap[ep.resxCulture].cancel || langMap.en.cancel;
    },
    /**
    * en: You cannot turn off Can login for yourself.
    */
    get CanDenyLogin_User_DenyLoginYourself() {
        return langMap[ep.resxCulture].CanDenyLogin_User_DenyLoginYourself || langMap.en.CanDenyLogin_User_DenyLoginYourself;
    },
    /**
    * en: You cannot turn off Can login for a user who is the sole administrator in the system.
    */
    get CanDenyLogin_User_LastAdministrator() {
        return langMap[ep.resxCulture].CanDenyLogin_User_LastAdministrator || langMap.en.CanDenyLogin_User_LastAdministrator;
    },
    /**
    * en: You cannot turn off Active for yourself.
    */
    get CanDisable_User_DisableYourself() {
        return langMap[ep.resxCulture].CanDisable_User_DisableYourself || langMap.en.CanDisable_User_DisableYourself;
    },
    /**
    * en: You cannot turn off Active for a user who is the sole administrator in the system.
    */
    get CanDisable_User_LastAdministrator() {
        return langMap[ep.resxCulture].CanDisable_User_LastAdministrator || langMap.en.CanDisable_User_LastAdministrator;
    },
    /**
    * en: User "{0}" cannot be deleted
    */
    get cant_delete_user() {
        return langMap[ep.resxCulture].cant_delete_user || langMap.en.cant_delete_user;
    },
    /**
    * en: Can't login
    */
    get cant_login() {
        return langMap[ep.resxCulture].cant_login || langMap.en.cant_login;
    },
    /**
    * en: Change password
    */
    get change_password() {
        return langMap[ep.resxCulture].change_password || langMap.en.change_password;
    },
    /**
    * en: Close
    */
    get close() {
        return langMap[ep.resxCulture].close || langMap.en.close;
    },
    /**
    * en: Convert
    */
    get convert_title() {
        return langMap[ep.resxCulture].convert_title || langMap.en.convert_title;
    },
    /**
    * en: Convert to regular user
    */
    get convert_to_regular() {
        return langMap[ep.resxCulture].convert_to_regular || langMap.en.convert_to_regular;
    },
    /**
    * en: Convert {0} to a regular user with the role:
    */
    get convert_to_regular_title() {
        return langMap[ep.resxCulture].convert_to_regular_title || langMap.en.convert_to_regular_title;
    },
    /**
    * en: Convert {0} to a regular user with the job role:
    */
    get convert_to_regular_title_with_job_role() {
        return langMap[ep.resxCulture].convert_to_regular_title_with_job_role || langMap.en.convert_to_regular_title_with_job_role;
    },
    /**
    * en: Make inactive
    */
    get deactivate() {
        return langMap[ep.resxCulture].deactivate || langMap.en.deactivate;
    },
    /**
    * en: Change user status to Inactive
    */
    get deactivateTitle() {
        return langMap[ep.resxCulture].deactivateTitle || langMap.en.deactivateTitle;
    },
    /**
    * en: Delete
    */
    get delete() {
        return langMap[ep.resxCulture].delete || langMap.en.delete;
    },
    /**
    * en: Delete user "{0}"?
    */
    get delete_confirm() {
        return langMap[ep.resxCulture].delete_confirm || langMap.en.delete_confirm;
    },
    /**
    * en: Delete skill
    */
    get delete_skill_title() {
        return langMap[ep.resxCulture].delete_skill_title || langMap.en.delete_skill_title;
    },
    /**
    * en: Delete team
    */
    get delete_team_title() {
        return langMap[ep.resxCulture].delete_team_title || langMap.en.delete_team_title;
    },
    /**
    * en: Delete permanently
    */
    get DeleteRateBtnTitle() {
        return langMap[ep.resxCulture].DeleteRateBtnTitle || langMap.en.DeleteRateBtnTitle;
    },
    /**
    * en: You are about to disable a permission in your role that allows you to edit your own and other users' permissions.
    */
    get Disable_Permission_Message() {
        return langMap[ep.resxCulture].Disable_Permission_Message || langMap.en.Disable_Permission_Message;
    },
    /**
    * en: You won't be able to edit user permissions anymore.
    */
    get Disable_Permission_Title() {
        return langMap[ep.resxCulture].Disable_Permission_Title || langMap.en.Disable_Permission_Title;
    },
    /**
    * en: Customer
    */
    get DisplayName_customerId() {
        return langMap[ep.resxCulture].DisplayName_customerId || langMap.en.DisplayName_customerId;
    },
    /**
    * en: Email
    */
    get DisplayName_email() {
        return langMap[ep.resxCulture].DisplayName_email || langMap.en.DisplayName_email;
    },
    /**
    * en: Billing hourly rate
    */
    get DisplayName_hourlyRate() {
        return langMap[ep.resxCulture].DisplayName_hourlyRate || langMap.en.DisplayName_hourlyRate;
    },
    /**
    * en: Internal hourly rate
    */
    get DisplayName_hourlyRateInternal() {
        return langMap[ep.resxCulture].DisplayName_hourlyRateInternal || langMap.en.DisplayName_hourlyRateInternal;
    },
    /**
    * en: Login
    */
    get DisplayName_login() {
        return langMap[ep.resxCulture].DisplayName_login || langMap.en.DisplayName_login;
    },
    /**
    * en: E-mail
    */
    get email() {
        return langMap[ep.resxCulture].email || langMap.en.email;
    },
    /**
    * en: Exclude
    */
    get exclude() {
        return langMap[ep.resxCulture].exclude || langMap.en.exclude;
    },
    /**
    * en: Only active
    */
    get filterbystatus_Active() {
        return langMap[ep.resxCulture].filterbystatus_Active || langMap.en.filterbystatus_Active;
    },
    /**
    * en: Active and inactive
    */
    get filterbystatus_All() {
        return langMap[ep.resxCulture].filterbystatus_All || langMap.en.filterbystatus_All;
    },
    /**
    * en: Only cannot login
    */
    get filterbystatus_CannotLogin() {
        return langMap[ep.resxCulture].filterbystatus_CannotLogin || langMap.en.filterbystatus_CannotLogin;
    },
    /**
    * en: Only inactive
    */
    get filterbystatus_Inactive() {
        return langMap[ep.resxCulture].filterbystatus_Inactive || langMap.en.filterbystatus_Inactive;
    },
    /**
    * en: Generate
    */
    get generate() {
        return langMap[ep.resxCulture].generate || langMap.en.generate;
    },
    /**
    * en: Guest portal.
    */
    get guest_portal_title() {
        return langMap[ep.resxCulture].guest_portal_title || langMap.en.guest_portal_title;
    },
    /**
    * en: Guests can interact with the system only via
    */
    get guests_interaction() {
        return langMap[ep.resxCulture].guests_interaction || langMap.en.guests_interaction;
    },
    /**
    * en: They don't require a license.
    */
    get guests_license() {
        return langMap[ep.resxCulture].guests_license || langMap.en.guests_license;
    },
    /**
    * en: Guests
    */
    get guests_users_tab_title() {
        return langMap[ep.resxCulture].guests_users_tab_title || langMap.en.guests_users_tab_title;
    },
    /**
    * en: Import
    */
    get import_title() {
        return langMap[ep.resxCulture].import_title || langMap.en.import_title;
    },
    /**
    * en: Inactive
    */
    get inactive() {
        return langMap[ep.resxCulture].inactive || langMap.en.inactive;
    },
    /**
    * en: Job roles have been updated successfully
    */
    get jobroles_updated_successfully() {
        return langMap[ep.resxCulture].jobroles_updated_successfully || langMap.en.jobroles_updated_successfully;
    },
    /**
    * en: Last visit
    */
    get lastActivityDate_title() {
        return langMap[ep.resxCulture].lastActivityDate_title || langMap.en.lastActivityDate_title;
    },
    /**
    * en: You cannot make this user be able to login because your license does not allow to add any more users that can login.
    */
    get licensing_limits_warning() {
        return langMap[ep.resxCulture].licensing_limits_warning || langMap.en.licensing_limits_warning;
    },
    /**
    * en: Name
    */
    get name_column_title() {
        return langMap[ep.resxCulture].name_column_title || langMap.en.name_column_title;
    },
    /**
    * en: This user has no entries yet
    */
    get no_sercurity_logs() {
        return langMap[ep.resxCulture].no_sercurity_logs || langMap.en.no_sercurity_logs;
    },
    /**
    * en: The password has been changed.
    */
    get password_changed() {
        return langMap[ep.resxCulture].password_changed || langMap.en.password_changed;
    },
    /**
    * en: Personal schedule
    */
    get personal_schedule_title() {
        return langMap[ep.resxCulture].personal_schedule_title || langMap.en.personal_schedule_title;
    },
    /**
    * en: Regular
    */
    get regular_users_tab_title() {
        return langMap[ep.resxCulture].regular_users_tab_title || langMap.en.regular_users_tab_title;
    },
    /**
    * en: Refresh
    */
    get reload() {
        return langMap[ep.resxCulture].reload || langMap.en.reload;
    },
    /**
    * en: Remove user?
    */
    get remove_confirm() {
        return langMap[ep.resxCulture].remove_confirm || langMap.en.remove_confirm;
    },
    /**
    * en: Assign
    */
    get reset() {
        return langMap[ep.resxCulture].reset || langMap.en.reset;
    },
    /**
    * en: By clicking "Generate" a new password will be generated and emailed to the user.
    */
    get reset_password_confirmation() {
        return langMap[ep.resxCulture].reset_password_confirmation || langMap.en.reset_password_confirmation;
    },
    /**
    * en: New password has been generated and sent.
    */
    get reset_password_done() {
        return langMap[ep.resxCulture].reset_password_done || langMap.en.reset_password_done;
    },
    /**
    * en: Generate & email password
    */
    get reset_password_menu_title() {
        return langMap[ep.resxCulture].reset_password_menu_title || langMap.en.reset_password_menu_title;
    },
    /**
    * en: Do you really want to generate and email the new password?
    */
    get reset_password_title() {
        return langMap[ep.resxCulture].reset_password_title || langMap.en.reset_password_title;
    },
    /**
    * en: Once assigned, the user will have the current role in all projects where this user is a member. The operation cannot be undone.
    */
    get reset_permissions_confirmation() {
        return langMap[ep.resxCulture].reset_permissions_confirmation || langMap.en.reset_permissions_confirmation;
    },
    /**
    * en: Current role was assigned.
    */
    get reset_permissions_done() {
        return langMap[ep.resxCulture].reset_permissions_done || langMap.en.reset_permissions_done;
    },
    /**
    * en: Assign current role
    */
    get reset_permissions_menu() {
        return langMap[ep.resxCulture].reset_permissions_menu || langMap.en.reset_permissions_menu;
    },
    /**
    * en: Do you want to assign the current role to all user's projects?
    */
    get reset_permissions_title() {
        return langMap[ep.resxCulture].reset_permissions_title || langMap.en.reset_permissions_title;
    },
    /**
    * en: Action
    */
    get security_logs_action() {
        return langMap[ep.resxCulture].security_logs_action || langMap.en.security_logs_action;
    },
    /**
    * en: Date
    */
    get security_logs_date() {
        return langMap[ep.resxCulture].security_logs_date || langMap.en.security_logs_date;
    },
    /**
    * en: Security log for
    */
    get security_logs_modal_title() {
        return langMap[ep.resxCulture].security_logs_modal_title || langMap.en.security_logs_modal_title;
    },
    /**
    * en: Security log
    */
    get security_logs_title() {
        return langMap[ep.resxCulture].security_logs_title || langMap.en.security_logs_title;
    },
    /**
    * en: Role changed from Guest to {0} by {1}.
    */
    get securitylog_msg_GuestConverted() {
        return langMap[ep.resxCulture].securitylog_msg_GuestConverted || langMap.en.securitylog_msg_GuestConverted;
    },
    /**
    * en: Login was changed by user {0}.
    */
    get securitylog_msg_LoginChanged() {
        return langMap[ep.resxCulture].securitylog_msg_LoginChanged || langMap.en.securitylog_msg_LoginChanged;
    },
    /**
    * en: Login was changed.
    */
    get securitylog_msg_LoginChangedBySelf() {
        return langMap[ep.resxCulture].securitylog_msg_LoginChangedBySelf || langMap.en.securitylog_msg_LoginChangedBySelf;
    },
    /**
    * en: Password was changed by user {0}.
    */
    get securitylog_msg_PasswordChanged() {
        return langMap[ep.resxCulture].securitylog_msg_PasswordChanged || langMap.en.securitylog_msg_PasswordChanged;
    },
    /**
    * en: Password was recovered.
    */
    get securitylog_msg_PasswordChangedByRecovery() {
        return langMap[ep.resxCulture].securitylog_msg_PasswordChangedByRecovery || langMap.en.securitylog_msg_PasswordChangedByRecovery;
    },
    /**
    * en: Password was changed.
    */
    get securitylog_msg_PasswordChangedBySelf() {
        return langMap[ep.resxCulture].securitylog_msg_PasswordChangedBySelf || langMap.en.securitylog_msg_PasswordChangedBySelf;
    },
    /**
    * en: Password was generated by user {0}.
    */
    get securitylog_msg_PasswordGenerated() {
        return langMap[ep.resxCulture].securitylog_msg_PasswordGenerated || langMap.en.securitylog_msg_PasswordGenerated;
    },
    /**
    * en: Password was generated.
    */
    get securitylog_msg_PasswordGeneratedBySelf() {
        return langMap[ep.resxCulture].securitylog_msg_PasswordGeneratedBySelf || langMap.en.securitylog_msg_PasswordGeneratedBySelf;
    },
    /**
    * en: Incorrect password.
    */
    get securitylog_msg_PasswordIncorrect() {
        return langMap[ep.resxCulture].securitylog_msg_PasswordIncorrect || langMap.en.securitylog_msg_PasswordIncorrect;
    },
    /**
    * en: Recovery request.
    */
    get securitylog_msg_RecoveryRequest() {
        return langMap[ep.resxCulture].securitylog_msg_RecoveryRequest || langMap.en.securitylog_msg_RecoveryRequest;
    },
    /**
    * en: Role changed from {0} to {1} by {2}.
    */
    get securitylog_msg_RoleChanged() {
        return langMap[ep.resxCulture].securitylog_msg_RoleChanged || langMap.en.securitylog_msg_RoleChanged;
    },
    /**
    * en: User was locked out after invalid password attempts.
    */
    get securitylog_msg_UserLockout() {
        return langMap[ep.resxCulture].securitylog_msg_UserLockout || langMap.en.securitylog_msg_UserLockout;
    },
    /**
    * en: User was locked out due to inactivity.
    */
    get securitylog_msg_UserLockoutDueToInactivity() {
        return langMap[ep.resxCulture].securitylog_msg_UserLockoutDueToInactivity || langMap.en.securitylog_msg_UserLockoutDueToInactivity;
    },
    /**
    * en: User was unlocked by user {0}.
    */
    get securitylog_msg_UserUnlocked() {
        return langMap[ep.resxCulture].securitylog_msg_UserUnlocked || langMap.en.securitylog_msg_UserUnlocked;
    },
    /**
    * en: 1#{0} User selected#{0} Users selected
    */
    get selected_users() {
        return langMap[ep.resxCulture].selected_users || langMap.en.selected_users;
    },
    /**
    * en: Add skills
    */
    get Set_skills() {
        return langMap[ep.resxCulture].Set_skills || langMap.en.Set_skills;
    },
    /**
    * en: Teams
    */
    get Set_teams() {
        return langMap[ep.resxCulture].Set_teams || langMap.en.Set_teams;
    },
    /**
    * en: Show
    */
    get show() {
        return langMap[ep.resxCulture].show || langMap.en.show;
    },
    /**
    * en: Show other reasons
    */
    get show_other_reasons() {
        return langMap[ep.resxCulture].show_other_reasons || langMap.en.show_other_reasons;
    },
    /**
    * en: Skills
    */
    get skills() {
        return langMap[ep.resxCulture].skills || langMap.en.skills;
    },
    /**
    * en: Skills have been updated successfully
    */
    get skills_updated_successfully() {
        return langMap[ep.resxCulture].skills_updated_successfully || langMap.en.skills_updated_successfully;
    },
    /**
    * en: The skill will be removed from other users’ profiles, where it is being used
    */
    get skillsDeleteConfirm() {
        return langMap[ep.resxCulture].skillsDeleteConfirm || langMap.en.skillsDeleteConfirm;
    },
    /**
    * en: Spaces
    */
    get spaces() {
        return langMap[ep.resxCulture].spaces || langMap.en.spaces;
    },
    /**
    * en: However, you have the option to make the user inactive, which will remove their visibility across {brandName}, except on the Users page and in project and task assignment history. This action will free up a license for another user.
    */
    get suggest_deactivate() {
        return langMap[ep.resxCulture].suggest_deactivate || langMap.en.suggest_deactivate;
    },
    /**
    * en: Teams
    */
    get teams() {
        return langMap[ep.resxCulture].teams || langMap.en.teams;
    },
    /**
    * en: Teams have been updated successfully
    */
    get teams_updated_successfully() {
        return langMap[ep.resxCulture].teams_updated_successfully || langMap.en.teams_updated_successfully;
    },
    /**
    * en: The team will be removed from every user's teams
    */
    get teamsDeleteConfirm() {
        return langMap[ep.resxCulture].teamsDeleteConfirm || langMap.en.teamsDeleteConfirm;
    },
    /**
    * en: 1#{0} second#{0} seconds
    */
    get TimerText() {
        return langMap[ep.resxCulture].TimerText || langMap.en.TimerText;
    },
    /**
    * en: Unlock
    */
    get unlock() {
        return langMap[ep.resxCulture].unlock || langMap.en.unlock;
    },
    /**
    * en: {0} has been converted successfully.
    */
    get user_conversion_done() {
        return langMap[ep.resxCulture].user_conversion_done || langMap.en.user_conversion_done;
    },
    /**
    * en: User conversion
    */
    get user_conversion_title() {
        return langMap[ep.resxCulture].user_conversion_title || langMap.en.user_conversion_title;
    },
    /**
    * en: A user with the specified email already exists
    */
    get user_duplicate_email_error() {
        return langMap[ep.resxCulture].user_duplicate_email_error || langMap.en.user_duplicate_email_error;
    },
    /**
    * en: A user with the specified login already exists
    */
    get user_duplicate_login_error() {
        return langMap[ep.resxCulture].user_duplicate_login_error || langMap.en.user_duplicate_login_error;
    },
    /**
    * en: You cannot turn on Can login for this user as there are no more license seats.
    */
    get user_licensing_limits_warning() {
        return langMap[ep.resxCulture].user_licensing_limits_warning || langMap.en.user_licensing_limits_warning;
    },
    /**
    * en: Requested User Not Found
    */
    get User_NotFound_Title() {
        return langMap[ep.resxCulture].User_NotFound_Title || langMap.en.User_NotFound_Title;
    },
    /**
    * en: Rate history
    */
    get userRates() {
        return langMap[ep.resxCulture].userRates || langMap.en.userRates;
    },
    /**
    * en: Changed by
    */
    get userRates_changed_by() {
        return langMap[ep.resxCulture].userRates_changed_by || langMap.en.userRates_changed_by;
    },
    /**
    * en: Date of change
    */
    get userRates_date() {
        return langMap[ep.resxCulture].userRates_date || langMap.en.userRates_date;
    },
    /**
    * en: Billing hourly rate
    */
    get userRates_hourlyRate() {
        return langMap[ep.resxCulture].userRates_hourlyRate || langMap.en.userRates_hourlyRate;
    },
    /**
    * en: Internal hourly rate
    */
    get userRates_hourlyRateInternal() {
        return langMap[ep.resxCulture].userRates_hourlyRateInternal || langMap.en.userRates_hourlyRateInternal;
    },
    /**
    * en: Rate history for {0}
    */
    get userRates_title() {
        return langMap[ep.resxCulture].userRates_title || langMap.en.userRates_title;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.users = usersResx;
